import Typography from '@mui/material/Typography';
import { TabPanel } from '@mui/lab';
import Box from '@mui/material/Box';
import DataTable from '../../../../../shared/components/Table';
import { GridColDef } from '@mui/x-data-grid';
import { Status } from '../../../../../shared/components/Status';
import { Dialog, DialogTitle, IconButton } from '@mui/material';
import { Search } from '@mui/icons-material';
import { SelectAutoCompleteComponent } from '../../../../../shared/components/SelectAutoCompleteComponent';
import { SelectAutoCompleteOptions } from '../../../../../shared/types/selectAutoComplete';
import { Button } from '../../../../Styles/ScreenStyle';
import * as Icon from '@mui/icons-material';
import {
  InputSelect,
  Item,
} from '../../../../../shared/components/InputSelect';

interface TabItemsProps {
  values: any;
  handleAutoCompleteSelected: any;
  modalSearchProduct: boolean;
  modalSearchTitle: string;
  handleCloseModalSearchProduct: () => void;
  handleModalSearchProduct: (value: any) => void;
  handleSearchProduct: (value: string) => void;
  confirmProductSelected: () => void;
  handleCreateProduct: () => void;
  productOptions: SelectAutoCompleteOptions[];
  activeProductSelected: SelectAutoCompleteOptions | null | undefined;
  showGroupProduct: boolean;
  paymentOptions: Item[];
  renderSelectGroup: () => void;
  handleGroupSelect: (value: any) => void;
  productGroup?: number;
}

export const TabItems = ({
  values,
  modalSearchProduct,
  modalSearchTitle,
  handleCloseModalSearchProduct,
  handleModalSearchProduct,
  handleSearchProduct,
  productOptions,
  handleAutoCompleteSelected,
  confirmProductSelected,
  activeProductSelected,
  handleCreateProduct,
  renderSelectGroup,
  showGroupProduct,
  paymentOptions,
  handleGroupSelect,
  productGroup,
}: TabItemsProps) => {
  const COLUMNS: GridColDef[] = [
    {
      field: 'product_id',
      headerName: 'Código',
      headerAlign: 'left',
      align: 'center',
      width: 80,
      renderCell: (params) => (
        <Box className={'flex flex-row justify-center items-center pt-5'}>
          <Status value={`${params.row.prod_id ? 'created' : 'not_created'}`} />
        </Box>
      ),
    },
    {
      field: 'prod_id',
      headerName: 'ID',
      headerAlign: 'center',
      align: 'center',
      width: 50,
      valueGetter: (value: any) => value,
    },
    {
      field: 'cProd',
      headerName: 'Cód. Item',
      headerAlign: 'left',
      align: 'left',
      width: 100,
      valueGetter: (value: any) => value,
    },
    {
      field: 'xProd',
      headerName: 'Descrição do Item',
      headerAlign: 'left',
      align: 'left',
      width: 500,
      valueGetter: (value: any) => value,
    },
    {
      field: 'NCM',
      headerName: 'NCM',
      headerAlign: 'left',
      align: 'left',
      width: 150,
      valueGetter: (value) => value,
    },
    {
      field: 'qCom',
      headerName: 'UN',
      headerAlign: 'left',
      align: 'left',
      width: 100,
      valueGetter: (value) => value,
    },
    {
      field: 'cEAN',
      headerName: 'Código de Barras',
      headerAlign: 'left',
      align: 'left',
      width: 300,
      valueGetter: (value) => value,
    },
    {
      field: 'prod_found',
      headerName: 'Ações',
      headerAlign: 'center',
      align: 'center',
      width: 100,
      renderCell: (params) => (
        <Box className={'flex flex-row justify-center items-center pt-2'}>
          {!params.value && (
            <IconButton onClick={() => handleModalSearchProduct(params.row)}>
              <Search />
            </IconButton>
          )}
        </Box>
      ),
    },
  ];

  return (
    <TabPanel value='4'>
      <Box className='grid grid-cols-8 gap-7 pt-4'>
        <Box>
          <Box className={'flex flex-row space-x-3'}>
            <Status value={'created'} />
            <Typography className={`text-[#4CAF50]`}>Localizado</Typography>
          </Box>
          <Box className={'flex flex-row space-x-3'}>
            <Status value={'not_created'} />
            <Typography className={`text-[#DEBE0B]`}>Não Localizado</Typography>
          </Box>
        </Box>
        <Dialog
          onClose={() => handleCloseModalSearchProduct()}
          open={modalSearchProduct}
        >
          <DialogTitle className='!font-bold !text-md'>
            {modalSearchTitle}
          </DialogTitle>
          <Box className={'px-6 pb-4 pt-2'}>
            <SelectAutoCompleteComponent
              value={''}
              name={'search'}
              options={productOptions}
              handleSearch={(value: string) => handleSearchProduct(value)}
              onSelectValue={handleAutoCompleteSelected}
            />
            {showGroupProduct && (
              <InputSelect
                label='Grupo'
                name='group_id'
                items={paymentOptions}
                className={'col-span-5 !mt-4'}
                handleChange={handleGroupSelect}
                helperText={''}
                error={false}
                // @ts-ignore - .
                value={productGroup ?? ''}
              />
            )}
            <Box className={'px-6 pt-8 text-center'}>
              <Button
                disabled={!activeProductSelected}
                variant='contained'
                className={'!px-6'}
                onClick={() => confirmProductSelected()}
                color='warning'
                startIcon={<Icon.Check />}
              >
                Confirmar
              </Button>
              {!showGroupProduct && (
                <Button
                  className={'!px-6'}
                  onClick={() => renderSelectGroup()}
                  variant='contained'
                  color='primary'
                  startIcon={<Icon.Create />}
                >
                  Criar
                </Button>
              )}
              {showGroupProduct && (
                <Button
                  disabled={!productGroup}
                  className={'!px-6'}
                  onClick={() => handleCreateProduct()}
                  variant='contained'
                  color='primary'
                  startIcon={<Icon.Create />}
                >
                  Salvar
                </Button>
              )}
            </Box>
          </Box>
        </Dialog>
        <Box className='col-span-8'>
          <DataTable
            columns={COLUMNS}
            rows={
              values?.nfeProc?.NFe?.infNFe?.det?.length
                ? values?.nfeProc?.NFe?.infNFe?.det.map(
                    (item: any, index: number) => {
                      return { ...item.prod, id: index };
                    }
                  )
                : []
            }
            showFilter={false}
            showButtonToXlsx={false}
          />
        </Box>
      </Box>
    </TabPanel>
  );
};
